import { createSlice } from "@reduxjs/toolkit";

const receiptsSlice = createSlice({
  name: "receipts",
  initialState: {
    Receipts: null,
  },
  reducers: {
    receiptsSuccess: (state, action) => {
      state.Receipts = action.payload;
    },
    clearReceipts: (state) => {
      state.Receipts = null;
    },
  },
});

export const { receiptsSuccess, clearReceipts } = receiptsSlice.actions;
export default receiptsSlice.reducer;
